export class ListChat {
    listchatdata = [];

    constructor() { }

    setdata(data) {
        this.listchatdata = data;
    }

    insertdata(data) {
        this.listchatdata.push(data)
    }

    gettiket(notiket) {
        for (const item of this.listchatdata) {
            if (item.no_tiket == notiket) {
                return item
            }
        }

        return {}
    }

    addmessage(notiket, data) {
        for (const item of this.listchatdata) {
            if (item.no_tiket == notiket) {
                item.updatemessage(data)
                return true
            }
        }

        return false
    }

    removetiket(notiket) {
        this.listchatdata = this.listchatdata.filter(
            el => el.no_tiket !== notiket
        )
    }

    hidetiket(notiket) {
        this.listchatdata.map((e) => {
            if (e.no_tiket == notiket) {
                e.visible = false
            }
        })
    }

    setchattobottom(notiket, indextiket = null) {
        var idx = indextiket
        if (indextiket == null) {
            idx = this.listchatdata.findIndex((e) => {
                return e.no_tiket == notiket
            })
        }

        const [item] = this.listchatdata.splice(idx, 1)
        this.listchatdata.push(item)
    }


    getlength() {
        return this.listchatdata.length;
    }
}
